var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReverseIcon = function SvgReverseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.2.1-Health-screening-/-Upcoming-/-View-more---missed",
    transform: "translate(-1199.000000, -356.191111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/09.Web/07.View-action/3-row/Right",
    transform: "translate(1183.000000, 331.191111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "repeat-1",
    mask: "url(#mask-2)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 5.000000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2796827,0.202759615 C11.5500721,-0.0675865385 11.9883894,-0.0675865385 12.2587788,0.202759615 L14.3357019,2.27968269 C14.6060481,2.55007212 14.6060481,2.98838942 14.3357019,3.25877885 L12.2587788,5.33570192 C11.9883894,5.60604808 11.5500721,5.60604808 11.2796827,5.33570192 C11.0093365,5.0653125 11.0093365,4.62699519 11.2796827,4.35660577 L12.1747933,3.46153846 L4.15492788,3.46153846 C3.42095192,3.46400481 2.71774038,3.75663462 2.19873029,4.27564904 C1.67971587,4.79466346 1.38706442,5.497875 1.38461538,6.23185096 L1.38461538,6.92307692 C1.38461538,7.30544712 1.07466058,7.61538462 0.692307692,7.61538462 C0.309954808,7.61538462 0,7.30544712 0,6.92307692 L0,6.23076923 L0,6.22869231 C0.00328846154,5.12857212 0.441761538,4.07449038 1.2196601,3.29659615 C1.99755865,2.51870192 3.05164904,2.08021154 4.15176923,2.07692308 L4.15384615,2.07692308 L12.1747933,2.07692308 L11.2796827,1.18185577 C11.0093365,0.911466346 11.0093365,0.473149038 11.2796827,0.202759615 Z M17.3076923,5.53846154 C17.6900625,5.53846154 18,5.84839904 18,6.23076923 L18,6.92307692 L18,6.92515385 C17.9967115,8.02527404 17.5582212,9.07935577 16.7803269,9.85725 C16.0024327,10.6351442 14.948351,11.0736346 13.8482308,11.0769231 L13.8461538,11.0769231 L5.82520673,11.0769231 L6.72031731,11.9719904 C6.99066346,12.2423798 6.99066346,12.6806971 6.72031731,12.9510865 C6.44992788,13.2214327 6.01161058,13.2214327 5.74122115,12.9510865 L3.66429808,10.8741635 C3.39395192,10.603774 3.39395192,10.1654567 3.66429808,9.89506731 L5.74122115,7.81814423 C6.01161058,7.54779808 6.44992788,7.54779808 6.72031731,7.81814423 C6.99066346,8.08853365 6.99066346,8.52685096 6.72031731,8.79724038 L5.82520673,9.69230769 L13.8451154,9.69230769 C14.5790913,9.68984135 15.2822596,9.39721154 15.801274,8.87819712 C16.3203317,8.35913942 16.6129615,7.65588462 16.6153846,6.92186538 L16.6153846,6.23076923 C16.6153846,5.84839904 16.9253221,5.53846154 17.3076923,5.53846154 Z"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReverseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reverse-icon.49af4140.svg";
export { ForwardRef as ReactComponent };